
export const ResourceReferenceTypes = [
    'FacilityInspection',
    'FileFolder',
    'Meeting',
    'ActionPlan',
    'SafetyInspection',
    'InternalArticle',
    'Article',
    'Incident',
    'FileUploadSlot',
    'ArticleVersion',
    'None'
] as const;

export type ResourceReferenceType = typeof ResourceReferenceTypes[number];

export type ResourceReference = {
    type: ResourceReferenceType;
    id: string;
};

// Careful, FileReference entityIds are generated based on FileReferenceType + _ + id
export const FileReferenceTypes = [
    'FacilityInspection',
    'FileFolder',
    'Meeting',
    'ActionPlan',
    'SafetyInspection',
    'InternalArticle',
    'Article',
    'Incident',
    'FileUploadSlot',
    'None'
] as const satisfies readonly ResourceReferenceType[];
export type FileReferenceType = typeof FileReferenceTypes[number];

export const LinkReferenceTypes = [
    'Meeting',
    'InternalArticle',
    'Article',
    'ActionPlan',
    'None'
] as const satisfies readonly ResourceReferenceType[];
export type LinkReferenceType = typeof LinkReferenceTypes[number];


export const CommentReferenceTypes = [
    'None', // dummy
    'ArticleVersion', //articleVersion
    'Article', // article
    'InternalArticle', // internalArticle
    'ActionPlan', // actionPlan
    'Incident' // incident
] as const satisfies readonly ResourceReferenceType[];
export type CommentReferenceType = typeof CommentReferenceTypes[number];